import * as React from "react";
import styles from "./DashboardCard.module.css";
import { cn } from "../../../utils/cn";

export interface DashboardCardProps
  extends React.HTMLAttributes<HTMLDivElement> {
  gap?: React.CSSProperties["gap"];
  align?: React.CSSProperties["alignItems"];
  justify?: React.CSSProperties["justifyContent"];
}

const DashboardCard = ({
  gap = "var(--space-xs)",
  align,
  justify,
  className,
  style,
  ...props
}: DashboardCardProps) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap,
        alignItems: align,
        justifyContent: justify,
        ...style,
      }}
      className={cn(styles.card, className)}
      {...props}
    />
  );
};

export { DashboardCard };
